if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.cart = document.querySelector('cart-drawer');
        this.form.addEventListener('submit', this.onSubmit.bind(this));
        if (this.cart) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      onSubmit(evt) {
        evt.preventDefault();
        if (this.submitButton.disabled) return;

        this.submitButton.disabled = true;

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((s) => s.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: formData,
        })
          .then((r) => r.json())
          .then((response) => {
            if (response.status) {
              console.error('Cart error:', response.description);
              return;
            }
            if (this.cart) {
              return fetch('/cart.js')
                .then((r) => r.json())
                .then((cart) => {
                  response.item_count = cart.item_count;
                  this.cart.renderContents(response);
                });
            } else {
              window.location = routes.cart_url;
            }
          })
          .catch(console.error)
          .finally(() => {
            this.submitButton.disabled = false;
          });
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
